export const ISO_3166_COUNTRIES: Array<{ code: string; name: string }> = [
  { code: "AF", name: "Afghanistan" },
  { code: "AX", name: "Åland" },
  { code: "AL", name: "Albanien" },
  { code: "DZ", name: "Algeriet" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AG", name: "Antigua och Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenien" },
  { code: "AU", name: "Australien" },
  { code: "AT", name: "Österrike" },
  { code: "AZ", name: "Azerbajdzjan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Vitryssland" },
  { code: "BE", name: "Belgien" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnien och Hercegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BR", name: "Brasilien" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgarien" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "CV", name: "Kap Verde" },
  { code: "KH", name: "Kambodja" },
  { code: "CM", name: "Kamerun" },
  { code: "CA", name: "Kanada" },
  { code: "CF", name: "Centralafrikanska republiken" },
  { code: "TD", name: "Tchad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "Kina" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Komorerna" },
  { code: "CD", name: "Demokratiska republiken Kongo" },
  { code: "CG", name: "Republiken Kongo" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Kroatien" },
  { code: "CU", name: "Kuba" },
  { code: "CY", name: "Cypern" },
  { code: "CZ", name: "Tjeckien" },
  { code: "DK", name: "Danmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominikanska republiken" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypten" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Ekvatorialguinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estland" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Etiopien" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "Frankrike" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgien" },
  { code: "DE", name: "Tyskland" },
  { code: "GH", name: "Ghana" },
  { code: "GR", name: "Grekland" },
  { code: "GD", name: "Grenada" },
  { code: "GT", name: "Guatemala" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "HU", name: "Ungern" },
  { code: "IS", name: "Island" },
  { code: "IN", name: "Indien" },
  { code: "ID", name: "Indonesien" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Irak" },
  { code: "IE", name: "Irland" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italien" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JO", name: "Jordanien" },
  { code: "KZ", name: "Kazakstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KP", name: "Nordkorea" },
  { code: "KR", name: "Sydkorea" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kirgizistan" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Lettland" },
  { code: "LB", name: "Libanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libyen" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Litauen" },
  { code: "LU", name: "Luxemburg" },
  { code: "MG", name: "Madagaskar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldiverna" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshallöarna" },
  { code: "MR", name: "Mauretanien" },
  { code: "MU", name: "Mauritius" },
  { code: "MX", name: "Mexiko" },
  { code: "FM", name: "Mikronesien" },
  { code: "MD", name: "Moldavien" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongoliet" },
  { code: "ME", name: "Montenegro" },
  { code: "MA", name: "Marocko" },
  { code: "MZ", name: "Moçambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Nederländerna" },
  { code: "NZ", name: "Nya Zeeland" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NO", name: "Norge" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua Nya Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Filippinerna" },
  { code: "PL", name: "Polen" },
  { code: "PT", name: "Portugal" },
  { code: "QA", name: "Qatar" },
  { code: "RO", name: "Rumänien" },
  { code: "RU", name: "Ryssland" },
  { code: "RW", name: "Rwanda" },
  { code: "KN", name: "Saint Kitts och Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "VC", name: "Saint Vincent och Grenadinerna" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "São Tomé och Príncipe" },
  { code: "SA", name: "Saudiarabien" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbien" },
  { code: "SC", name: "Seychellerna" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SK", name: "Slovakien" },
  { code: "SI", name: "Slovenien" },
  { code: "SB", name: "Salomonöarna" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "Sydafrika" },
  { code: "SS", name: "Sydsudan" },
  { code: "ES", name: "Spanien" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Surinam" },
  { code: "SE", name: "Sverige" },
  { code: "CH", name: "Schweiz" },
  { code: "SY", name: "Syrien" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tadzjikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Östtimor" },
  { code: "TG", name: "Togo" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad och Tobago" },
  { code: "TN", name: "Tunisien" },
  { code: "TR", name: "Turkiet" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TV", name: "Tuvalu" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraina" },
  { code: "AE", name: "Förenade Arabemiraten" },
  { code: "GB", name: "Storbritannien" },
  { code: "US", name: "USA" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "YE", name: "Jemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

export const COUNTRY_CODE_OPTIONS = ISO_3166_COUNTRIES.map(({ code, name }) => ({
  label: `${code} - ${name}`,
  value: code,
  searchLabel: `${code} ${name}`,
}));
